import React, { useEffect, useState } from "react"
import PropTypes from "prop-types"
import { Row, Spinner } from "reactstrap"
import API from "../../apis"
import ISGGB from "../../assets/images/ismsf.png"
import tunisie_rep from "../../assets/images/tn_rep.png"

const EmploiTemps = props => {
  const userAuthEtudiant = JSON.parse(localStorage.getItem("userAuthEtudiant"))

  const etudiant_id = userAuthEtudiant?.user?.id_etudiant
  const annee_id = userAuthEtudiant?.user?.annee_id

  const [loading, setLoading] = useState(false)
  const [pdfUrl, setPdfUrl] = useState(null)

  useEffect(() => {
    const loadPdf = async () => {
      try {
        setLoading(false)

        /*
        |--------------------------------------------------------------------------
        | Appel API PDF étudiant
        |--------------------------------------------------------------------------
        */

        const response = await API.post(
          "emploi/group/get_emploi_group_pdf",
          {
            annee_id: annee_id,
            semestre_id: props.semestre_value,
            etudiant_id: etudiant_id,
          },
          {
            responseType: "blob",
          }
        )

        /*
        |--------------------------------------------------------------------------
        | Création du Blob PDF
        |--------------------------------------------------------------------------
        */

        const blob = new Blob([response.data], {
          type: "application/pdf",
        })

        /*
        |--------------------------------------------------------------------------
        | Création URL temporaire pour iframe
        |--------------------------------------------------------------------------
        */

        const url = URL.createObjectURL(blob)

        setPdfUrl(url)
        setLoading(true)
      } catch (error) {
        console.error("Erreur chargement PDF étudiant :", error)

        setLoading(true)
      }
    }

    if (etudiant_id && annee_id && props.semestre_value) {
      loadPdf()
    }
  }, [props.semestre_value])

  /*
  |--------------------------------------------------------------------------
  | Nettoyage URL Blob
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    return () => {
      if (pdfUrl) {
        URL.revokeObjectURL(pdfUrl)
      }
    }
  }, [pdfUrl])

  return (
    <React.Fragment>
      {loading ? (
        <Row>
          <div className="container">
            <div
              className="row"
              style={{
                paddingTop: "30px",
              }}
            >
              <div
                className="col"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                République Tunisienne
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  {"Ministère de l'enseignement supérieur,"}
                </div>
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  de la Recherche Scientifique
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  Université de Sfax
                </div>
                <div
                  className="col"
                  style={{
                    marginLeft: 0,
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                  }}
                >
                  Institut Supérieur de Musique de Sfax
                </div>
              </div>

              <div
                className="col"
                style={{
                  position: "relative",
                  textAlign: "center",
                }}
              >
                <img
                  alt="ISMSF"
                  style={{
                    width: "70%",
                  }}
                  src={ISGGB}
                />
              </div>

              <div
                className="col"
                style={{
                  position: "relative",
                  textAlign: "center",
                }}
              >
                <img
                  alt="Tunisie"
                  style={{
                    width: "28%",
                  }}
                  src={tunisie_rep}
                />
              </div>

              <div
                className="col"
                style={{
                  fontSize: "12px",
                  textAlign: "center",
                }}
              >
                الجمهورية التونسية
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                  }}
                >
                  وزارة التعليم العالي والبحث العلمي
                </div>
                <div
                  className="col"
                  style={{
                    fontSize: "12px",
                    textAlign: "center",
                    fontWeight: "bold",
                    paddingTop: "10px",
                  }}
                >
                  جامعة ﺻﻔﺎﻗﺲ
                </div>
                <div
                  className="col"
                  style={{
                    textAlign: "center",
                    marginRight: 0,
                    fontSize: "12px",
                    fontWeight: "bold",
                  }}
                >
                  {"اﻟﻤﻌﻬﺪ اﻟﻌﺎﻟﻲ ﻟﻠﻤﻮﺳﻴﻘﻰ ﺑﺼﻔﺎﻗﺲ "}
                </div>
              </div>
            </div>

            <hr
              style={{
                width: "100%",
                marginTop: "0.1%",
                color: "black",
              }}
            />
          </div>

          {/*
          |--------------------------------------------------------------------------
          | IFRAME PDF
          |--------------------------------------------------------------------------
          */}

          <div
            style={{
              width: "100%",
              padding: "0px 15px",
            }}
          >
            {pdfUrl ? (
              <iframe
                src={pdfUrl}
                title="Emploi étudiant"
                width="100%"
                height="900px"
                style={{
                  border: "1px solid #ddd",
                }}
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "30px",
                }}
              >
                Aucun emploi disponible.
              </div>
            )}
          </div>
        </Row>
      ) : (
        <div>
          <div
            style={{
              display: "flex",
              justifyContent: "center",
            }}
          >
            <Spinner type="grow" className="ms-6" color="primary" />
          </div>

          <h4
            style={{
              textAlign: "center",
              marginTop: "2%",
            }}
            className="ms-6"
          >
            Chargement ...
          </h4>
        </div>
      )}
    </React.Fragment>
  )
}

export default EmploiTemps

EmploiTemps.propTypes = {
  history: PropTypes.object,

  semestre_value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),

  semestre_label: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
